import React from 'react'
import { useAppDispatch } from '../../../../../app/store/hooks/Redux'
import { BpButton } from '../../../buttons/bp-button/BpButton'
import { BpAnchor } from '../../../text/anchor/BpAnchor'
import { useGetSiteArticleSettingsQuery } from '../../../../../app/api'
import { useTranslation } from 'react-i18next'

export const ContactsModal = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { data } = useGetSiteArticleSettingsQuery()

  return (
    <div className={'flex h-full flex-col'}>
      <h3
        className={
          'flex min-h-[55px] w-full items-center border-b-[3px] border-b-[#00326D]/[.02] px-[24px] text-[20px] font-medium'
        }
      >
        {t('components.guideButton.askSpecialist')}
      </h3>
      <div
        className={'flex h-full flex-1 flex-col items-center justify-center gap-[12px] px-[24px]'}
      >
        {data?.data?.items?.buttons?.map(
          ({ name, url }, index) => (
            <BpButton
              key={index}
              className={'w-[200px]'}
              size={'sm'}
              onClick={() => window.open(url, '_blank')}
            >
              {name}
            </BpButton>
          ),
        )}
        <div className={'flex justify-center gap-[6px]'}>
          {data?.data?.items?.contacts?.map(
            ({ name, url }, index) => (
              <BpAnchor key={index} className={'text-[15px]'} href={url} target='_blank'>
                {name}
              </BpAnchor>
            ),
          )}
        </div>
      </div>
    </div>
  )
}
